'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dateFns = require('date-fns');

var _dualDateDigit = require('../lib/dualDateDigit.date');

var _dualDateDigit2 = _interopRequireDefault(_dualDateDigit);

var _hourPart = require('../lib/hourPart.date');

var hourPart = _interopRequireWildcard(_hourPart);

var _fillArrayWithNumbers = require('../../../libs/fillArrayWithNumbers');

var _fillArrayWithNumbers2 = _interopRequireDefault(_fillArrayWithNumbers);

var _isDisabled = require('../lib/isDisabled.date');

var _isDisabled2 = _interopRequireDefault(_isDisabled);

var _Container = require('./components/Container.TimePicker');

var _Container2 = _interopRequireDefault(_Container);

var _Row = require('./components/Row.TimePicker');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Lib
// Components


var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.dom = null, _this.hours = function () {
      return (0, _fillArrayWithNumbers2.default)(0, 11).map(_dualDateDigit2.default);
    }, _this.minutes = function () {
      return (0, _fillArrayWithNumbers2.default)(0, 55, _this.props.step).map(_dualDateDigit2.default);
    }, _this.parts = function () {
      return ['am', 'pm'];
    }, _this.format = function (hour, minutes, part) {
      return (0, _dualDateDigit2.default)(hourPart.enc(hour, part)) + ':' + minutes + ':00';
    }, _this.isSelected = function (hour, minutes, part) {
      return _this.format(hour, minutes, part) === _this.props.value;
    }, _this.scrollToSelectedOnVisible = function () {
      var selected = (0, _jquery2.default)('.selectedTime', _this.dom);
      if (!selected || !selected.length) return;
      var container = (0, _jquery2.default)(_this.dom);
      var scrollTop = selected.offset().top - container.offset().top + container.scrollTop() - 6;
      container.stop().animate({
        scrollTop: scrollTop
      }, 200);
    }, _this.isDisabled = function (hour, minute, part) {
      var _this$props = _this.props,
          disabledDates = _this$props.disabledDates,
          date = _this$props.date;
      if (!disabledDates.length) return false;
      var hours = Number(hour) + (part === 'pm' ? 12 : 0);
      var dateToCheck = date ? (0, _dateFns.parse)(date) : new Date();
      dateToCheck.setHours(hours);
      dateToCheck.setMinutes(Number(minute));
      dateToCheck.setSeconds(0);
      dateToCheck.setMilliseconds(0);
      return (0, _isDisabled2.default)(disabledDates, dateToCheck);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DatePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.value) this.scrollToSelectedOnVisible();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value && this.props.value) this.scrollToSelectedOnVisible();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          inline = _props.inline,
          _short = _props.short;
      return _react2.default.createElement('div', null, _react2.default.createElement(_Container2.default, {
        innerRef: function innerRef(dom) {
          _this2.dom = dom;
        },
        inline: inline,
        short: _short
      }, this.parts().map(function (part) {
        return _this2.hours().map(function (hour) {
          return _this2.minutes().map(function (minute) {
            return _react2.default.createElement(_Row2.default, {
              key: part + '-' + hour + '-' + minute,
              onClick: function onClick() {
                return _this2.props.onChange(_this2.format(hour, minute, part));
              },
              selected: _this2.isSelected(hour, minute, part),
              className: _this2.isSelected(hour, minute, part) ? 'selectedTime' : '',
              disabled: _this2.isDisabled(hour, minute, part)
            }, hour === '00' && part === 'pm' ? '12' : hour, ':', minute, part);
          });
        });
      })));
    }
  }]);

  return DatePicker;
}(_react.Component);

DatePicker.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  step: _propTypes2.default.number,
  inline: _propTypes2.default.bool,
  disabledDates: _propTypes2.default.array,
  date: _propTypes2.default.string
};
DatePicker.defaultProps = {
  step: 15,
  inline: false,
  short: false,
  disabledDates: [],
  date: null
};
exports.default = DatePicker;